var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.502,
    cy: 17.402,
    r: 16.5,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.746 10.655-10.026 3.58v5.542l.592.211-.892 1.785a1.582 1.582 0 0 0 .915 2.21l3.233 1.078a1.595 1.595 0 0 0 1.917-.794l1.031-2.064 3.23 1.154a.792.792 0 0 0 1.057-.745V11.4a.792.792 0 0 0-1.057-.745zM17.069 23.56l-3.233-1.078.978-1.956 3.2 1.143-.945 1.89zm-7.516-3.782h1.584v-5.542H9.553c-.873 0-1.583.71-1.583 1.584v2.375c0 .873.71 1.583 1.583 1.583z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.b10574a7ded1203bdc3ac1f447f02a2f.svg";
export { ForwardRef as ReactComponent };